import { tableId } from '../../constants';

export const getPopupContainer = () => document.getElementById(tableId);
